import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AnnoncesParCategorie from "./AnnonceParCategorie";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Annonces = () => {
  const [selectedCategorieId, setSelectedCategorieId] = useState(null);

  const categories = [
    { id: 1, name: "Véhicule et engins" },
    { id: 2, name: "Logement" },
    { id: 3, name: "Terrain" },
    { id: 10, name: "Formation" },
    { id: 5, name: "Travail" },
    { id: 13, name: "Artisanat" },
    { id: 6, name: "Alimentation" },
    { id: 12, name: "Plantes" },
    { id: 7, name: "Animaux" },
    { id: 9, name: "Équipement évènementiel" },
    { id: 8, name: "Équipement de la maison" },
    { id: 11, name: "Matériaux et outillage" },
  ];

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const catIdFromUrl = queryParams.get("categorieId");

    if (catIdFromUrl) {
      setSelectedCategorieId(Number(catIdFromUrl));
    }
  }, [location.search]);

  const handleCategoryClick = (id) => {
    setSelectedCategorieId(id);
  };

  return (
    <div>
      <Header />
      <div className="categorieList">
        <h2 className="titreCat">Catégories</h2>
        <ul>
          {categories.map((cat) => (
            <li key={cat.id}>
              <button
                className="button"
                onClick={() => handleCategoryClick(cat.id)}
              >
                {cat.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {selectedCategorieId && (
        <AnnoncesParCategorie categorieId={selectedCategorieId} />
      )}
      <Footer />
    </div>
  );
};

export default Annonces;
